/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneMain from 'base/components/standalone/Main';

export const DynamicStandaloneMain = StandaloneMain;
export type DynamicStandaloneMainProps = PropsFromComponent<typeof StandaloneMain>;

export const DynamicStandaloneMainWith = (extras: DynamicStandaloneExtras): typeof StandaloneMain => {
    return function DynamicStandaloneMain(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Main');
        return <StandaloneMain {...mergeProps({ options: { theme } }, props)} />;
    }
}